export const MESSAGE_MONTO_COMTEMPLA_PENALIDAD =
  "Este monto contempla la tasa moratoria o la penalidad por días de atraso";
export const TRANSFERENCIA_SUJETA_TIPO_CAMBIO_ACTUAL =
  "Esta operación está sujeta al tipo de cambio actual.";
export const MESSAGE_NUMERO_CUENTA_BANCOS_IFIS =
  "BCP y SCOTIABANK: Número de cuenta - Otros: Código de cuenta interbancario (CCI)";
export const MESSAGE_PAGO_CUENTA_CARGO = "Solo se monstrará cuentas VIGENTES.";
export const MESSAGE_TRANSFERENCIA_CUENTA_ORIGEN =
  "Sólo se mostrará cuentas de ahorros VIGENTES y cuenta CTS con saldo disponible.";
export const MESSAGE_TRANSFERENCIA_PRYMERA_CUENTA_ORIGEN =
  "Sólo se mostrará cuentas de ahorros VIGENTES con saldo disponible.";
export const MESSAGE_TRANSFERENCIA_CUENTA_DESTINO =
  "Sólo se mostrará cuentas de ahorros VIGENTES.";
//Clave SMS
export const MESSAGE_USUARIO_SIN_CLAVE_DOBLE_FACTOR =
  "No estás afiliado a la Clave Dinámica.";
export const MESSAGE_NO_AFILIADO_TRANSFERENCIAS_CLAVE_SMS =
  "No estás afiliado a la Clave SMS, sin embargo, puedes realizar transferencias entre tus propias cuentas.";
//Disponibilidad de pago
export const MESSAGE_OPERACIONES_NO_DISPONIBLE =
  "Servicio no disponible. Por favor intente más tarde.";
export const MESSAGE_YA_AFILIADO_CLAVE_SMS =
  "Ya estás afiliado a la Clave SMS.";
export const MESSAGE_CLAVE_DOBLE_FACTOR_NO_VALIDA = "Clave no válida";
export const MESSAGE_CODIGO_VERIFICACION_REQUERIDO = "Código de verificación es requerido";
export const MESSAGE_CODIGO_VERIFICACION_NO_VALIDA = "Código de verificación no válido";
